
<template>
    <div>
        <!-- <router-view></router-view> -->
        <div v-if="isInitializing" class="loading text-center">
            <RotateSquare3 :size="90"></RotateSquare3>
        </div>
        
        <div v-else-if="!validacionCorreoComponente">
            <div v-if="!isSearchEnabled" class="row animated fadeIn">
                <div class="col-md-2 col-sm-12 col-xs-12"></div>
                <div class="col-md-8 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="card-header bgm-gray text-center"><h2>INFORMACIÓN</h2></div>
                        <div class="card-body card-padding text-center">
                            <p class="f-500">
                                <h4>
                                    En este momento no se encuentra habilitado el período de consultas del padrón electoral.
                                </h4>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="row animated fadeIn">
                <div class="col-md-2 col-sm-12 col-xs-12"></div>
        
                <div class="col-md-8 col-sm-12 col-xs-12">
        
                    <div class="card">
                        <div class="card-header bgm-gray text-center"><h2>CONSULTAR PADRÓN ELECTORAL</h2></div>
                        
                        <div class="card-header ch-alt text-center">
                            <h2>Número de Documento</h2>
                        </div>
        
                        <div class="card-body card-padding text-center">
                            <form @submit.prevent="validateBeforeSubmit">
                                <div class="form-group" :class="{'has-error': errors.has('document_number')}">
                                    <div class="fg-line">
                                        <input type="text" v-model="document_number" v-validate="'required'" class="form-control input-lg text-center" placeholder="Ingrese su número de documento" autofocus>
                                    </div>
                                    <small v-if="errors.has('document_number')" class="help-block">Debe ingresar un número de documento válido</small>
                                </div>
                                
                                <div class="row" v-if="enabledCaptcha">
                                    <div class="col-md-12">
                                        <vue-recaptcha
                                            ref="recaptcha"
                                            @expired="onCaptchaExpired"
                                            :sitekey="configCaptcha"
                                            :loadRecaptchaScript="true">
                                        </vue-recaptcha>
                                    </div>
                                </div>
        
                                <div class="row">
                                    <div class="col-md-12">
                                        <button type="submit" class="btn btn-lg m-t-30 btn-primary text-center">Consultar Padrón</button>
                                    </div>
                                </div>
                                
                                
                            </form>
        
                        </div>
                    </div>
        
                    <div v-if="showLoading" class="loading">
                        <RotateSquare3 :size="90"></RotateSquare3>
                    </div>
                    <div v-else>
        
                        <div v-if="dataElector" class="jumbotron text-center">
                            <p class="c-bluegray f-500">Nombres y Apellido</p>
                            <h3>{{ dataElector.fullname }}</h3>
                            <h3>{{ dataElector.document_types_code }} {{ dataElector.document_number }}</h3>
                            
                            <br>
                            
                            <p class="m-t-25 c-bluegray f-500">Padrón Electoral</p>
                            <h3>{{ dataElector.electoral_lists_name }}</h3>
                            <p>Subpadrón: {{ dataElector.electoral_sublists_name }}</p>
                            
                            
                            <span v-if="dataElector.docket">
                                <p class="m-t-25 c-bluegray f-500"> Voto a distancia</p>
                                <p>
                                    
                                        <span>👉 Ha optado por el voto a distancia</span>
                                        <br>
                                        <span v-if="dataElector.is_valid">
                                            ✅ Su dirección de correo electrónico se encuentra validada
                                        </span>
                                        <span v-else>
                                            👉 Su dirección de correo electrónico aún no ha sido validada
                                        </span>
                                    

                                    <div class="row" v-if="infoVotacion && infoVotacion.validacionCorreo">
                                        <div class="col-md-12">
                                            <button type="" @click="sendEmail" class="btn btn-lg m-t-30 btn-primary text-center">
                                                {{ dataElector.is_valid ? 'Re-validar dirección de correo electrónico':'Validar dirección de correo electrónico' }}
                                            </button>
                                        </div>
                                        <br>
                                        <small><i>En caso de no recibir el correo electrónico, por favor comunícate con tu Facultad.</i></small>
                                    </div>


                                </p>

                            </span>

                            <br><br>
                            <p v-if="infoVotacion">{{infoVotacion?infoVotacion.fecha:' '}}</p>
                        </div>
        
                        <div v-if="!dataElector && dataEmpty" class="jumbotron text-center">
                            <h3>No hay registro para el número de documento ingresado.</h3>
                            <p v-if="infoVotacion">{{infoVotacion?infoVotacion.fecha:' '}}</p>
                        </div>
                    
                    </div>
                
                </div>
        
                <div class="col-md-2 col-sm-12 col-xs-12"></div>
        
            </div>
        </div>

        <div v-else-if="validacionCorreoComponente">
            <validacion-correo :token="token" :elector_id="dataElector.electors_id"> </validacion-correo>    
        </div>
    </div>
</template>

<script>
import { HTTP_INFO_VOTACION, HTTP_GURU_BACKEND, HTTP_CONFIG, swal } from '../../share.js';
import { RotateSquare3 } from 'vue-loading-spinner';
import moment from 'moment'
import VueRecaptcha from 'vue-recaptcha';
import validacionCorreo from '../validacion-correo/validacion-correo.vue'

export default {
    data() {
        return {
            dataElector: '',
            dataEmpty: false,
            document_number: '',
            showLoading: false,
            infoVotacion : null,
            electoralPeriods : [],
            isSearchEnabled : false,
            isInitializing : true,
            validacionCorreoComponente : false,
            token : null,
            configCaptcha: null,
            
        }
    },
    computed: {
        enabledCaptcha() {
            return !!this.configCaptcha;
        }
    },
    components: {
        RotateSquare3,
        VueRecaptcha,  
        validacionCorreo,   
    },
    created() {
        this.getConfig();
        this.getElectoralPeriods();
        this.getInfoVotacion();
    },
    mounted() {

        const windowPath = window.location.pathname

        const match = windowPath.match(/validacion-correo\/([^/]+)/);

        if (match) {
            this.token = match[1];
            this.validacionCorreoComponente = true;
        }
    },
    methods: {
        getConfig() {
            HTTP_CONFIG.get()
                .then(response => {
                    this.configCaptcha = response.data?.google?.captcha;
                })
                .catch(error => {
                    console.error("Error loading config", error);
                });
        },
        
        validateBeforeSubmit(e) {
            
            this.dataElector = '';

            this.$validator.validateAll().then(() => {
                if (!this.errors.any()) {
                    if (this.enabledCaptcha) {
                        /* global grecaptcha */
                        let captchaResponse = grecaptcha.getResponse(this.rcapt_id);
                        if (captchaResponse.length > 0) {
                            grecaptcha.reset();
                            
                            this.consultarPadron();
                        } else {
                            swal({title: '', text: 'Por favor, haga clic indicando que no es un robot', type: 'info' });

                        }
                    } else {
                        this.consultarPadron();
                    }
                } else {
                    swal({title: 'Documento Incorrecto', text: 'Ingrese un número de documento válido', type: 'info' });
                }
            }).catch(() => {
                swal({title: 'Oops!', text: 'Parece que algo no anduvo bien, revisa el número de documento ingresado e intenta nuevamente', type: 'warning' });
            });
        
        },
        consultarPadron() {
            let self = this;
            
            this.showLoading = true;

            self.dataElector = '';
            self.dataEmpty = false;

            HTTP_GURU_BACKEND.get('guaraniElectors/' + self.document_number.trim() + '/electoralListDetails')
                .then(response => {

                    if (response.status === 200) {
                        if (response.data.length > 0) {
                            let padronActivo = response.data.filter(elector => elector.active);
                            self.dataElector = padronActivo[0];
                            self.dataEmpty = false;
                        } else {
                            self.dataEmpty = true
                        }

                    } else {
                        swal({title: 'Error: ' + response.status, text: response.statusText, type: 'error' });
                    }
                }).then(data => {
                    this.showLoading = false;
                }).catch(e => {
                    this.showLoading = false;
                    self.dataEmpty = true
            });  
        },
        limpiarElector() {
            this.dataElector = '';
        },
        getInfoVotacion(){
            HTTP_INFO_VOTACION.get()
            .then(response =>{
                this.infoVotacion = response.data;

            })
            .catch(error => {
            })
            
        },
        getElectoralPeriods(){
            HTTP_GURU_BACKEND.get('electoralPeriods?active=true')
            .then(response => {
                if(response.data.length){
                    this.electoralPeriods = response.data;
                    this.ifSearchEnabled(this.electoralPeriods);
                }else{ /* En el caso de que no se encuentren períodos electorales activos */
                    this.isInitializing = false;
                    this.isSearchEnabled = false;
                }
            })
            .catch(error => {
                this.isInitializing = false;
                this.isSearchEnabled = false;
            })
        },
        ifSearchEnabled(periods){
            let today = moment();
            this.isSearchEnabled = periods.some(ep => {
                return moment(ep.public_search_start_date) <= today && today <= moment(ep.public_search_end_date)
            })
            this.isInitializing = false;
        },
        onCaptchaExpired: function () {
            this.$refs.recaptcha.reset();
        },
        sendEmail(){
            this.isInitializing = true;

            let bodyToSend = {
                electors_id: this.dataElector.electors_id
            }

            HTTP_GURU_BACKEND.post('email-validation-tokens',bodyToSend)
            .then(response => {
                this.isInitializing = false;
                swal({title: 'Correo electrónico enviado', text: 'Hemos enviado un correo electrónico para que puedas validarlo. Revisa tu bandeja de entrada. Ten encuenta que puede demorar unos minutos en llegar y que puede hacerlo en SPAM.', type: 'success' })
                .then(()=>{
                    this.$router.push('/consultas');
                })

            })
            .catch(error => {
                this.isInitializing = false;
                swal({
                    title: "Algo salió mal",
                    text: "Ha sucedido algo inesperado. No hemos podido enviarte el correo electrónico. Intenta nuevamente y si persiste el inconveniente contácte con tu Facultad.",
                    type: "warning"
                })
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    
    .jumbotron {
        h3 {
            color: #666666;
        }

        p{
            color: #000000
        }
    }


    iframe {
        margin: 20px 0px;
        text-align: -webkit-center;
        text-align: center;
    }


</style>